





































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class ProductSearchDateRangeInput extends Vue {
  @Prop() value!: { startDate: string; endDate: string };

  get dateRange() {
    return {
      start: moment(this.value.startDate).format('YYYY-MM-DD'),
      end: moment(this.value.endDate).format('YYYY-MM-DD'),
    };
  }

  set dateRange(value: any) {
    this.$emit('input', {
      startDate: new Date(moment(value.start).format('YYYY-MM-DD')),
      endDate: new Date(moment(value.end).format('YYYY-MM-DD')),
    });
  }
}
